import React from "react";
import { Steps, StepsProps } from "antd";

import * as styles from "./CustomStepsStyle.module.scss";

const CustomSteps = (props: StepsProps) => {
  return <Steps {...props} className={styles.steps} />;
};

export default CustomSteps;
